"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(message, err) {
        var _this = _super.call(this, message) || this;
        _this.err = err;
        return _this;
    }
    ApiError.prototype.Error = function () {
        return this.err;
    };
    return ApiError;
}(Error));
exports.ApiError = ApiError;
exports.ErrorHandler = function (resp) {
    if (resp.redirected) {
        console.log(resp);
        window.top.location = resp.headers.get('Location');
    }
    if (!resp.ok) {
        if (resp.status === 400 || resp.status === 401 || resp.status === 403 || resp.status === 404) {
            return resp.json().then(function (err) {
                throw new ApiError("whoops " + resp.status + ": " + resp.statusText, err);
            });
        }
        else {
            throw new ApiError(resp.statusText, {
                message: 'Sever is down',
            });
        }
    }
    return resp;
};
